import React from 'react';
export default function IncidentTimeline({ items }: Readonly<{ items: any[] }>) {
  if (!items?.length) return <div style={{ color: '#6b7280' }}>No incidents</div>;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr 120px', gap: 6 }}>
      <div style={{ fontSize: 12, color: '#6b7280' }}>When</div>
      <div style={{ fontSize: 12, color: '#6b7280' }}>What</div>
      <div style={{ fontSize: 12, color: '#6b7280' }}>Impact</div>
      {items.map((it: any, idx: number) => (
        <React.Fragment key={idx}>
          <div style={{ color: '#111827', fontSize: 13 }}>{it.when}</div>
          <div style={{ color: '#111827', fontSize: 13 }}>{it.text}</div>
          <div style={{ color: '#111827', fontSize: 13 }}>SEV{it.sev}</div>
        </React.Fragment>
      ))}
    </div>
  );
}
